
<div class="alert  alerta" role="alert">
  <p id="id-p-{{id}}" [ngClass]="{active: contentActive == true}">
    <ng-content></ng-content>
  </p>
  <button id="id-button-{{id}}" *ngIf="!contentActive" class="show-mobile-only" (click)="toggleContent()">Saiba mais</button>
  <button id="id-button-{{id}}" *ngIf="contentActive" class="show-mobile-only" (click)="toggleContent()">Ver menos</button>
</div>
